<script>
export default {
  name: 'ConfirmationPrompt',
  props: {
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    confirmationText: {
      type: String,
      required: true,
    },
    confirmText: {
      type: String,
      default: 'Confirm',
    },
    cancelText: {
      type: String,
      default: 'Cancel',
    },
    type: {
      type: String,
      default: 'is-primary',
    },
  },
  data: () => ({
    value: '',
    isProcessing: false,
  }),
  computed: {
    isValid() {
      return this.value.trim().toLowerCase() === this.confirmationText.toLowerCase();
    },
    confirmDisabled() {
      return !this.isValid || this.isProcessing;
    },
  },
  methods: {
    setProcessing(value) {
      this.isProcessing = value;
    },
    close() {
      this.$emit('close');
    },
    handleCancel() {
      if (this.isProcessing) {
        return;
      }
      this.$emit('cancel');
      this.close();
    },
    handleConfirm() {
      if (this.confirmDisabled) {
        return;
      }

      this.$emit('confirm', {
        value: this.value,
        setProcessing: this.setProcessing,
        close: this.close,
      });
    },
  },
};
</script>

<template>
  <section class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">{{ title }}</p>
      <button type="button" class="delete" aria-label="close" @click="handleCancel" />
    </header>
    <section class="modal-card-body">
      <p class="mb-4" v-html="message" />
      <b-field>
        <b-input
          v-model="value"
          :placeholder="confirmationText"
          autocomplete="off"
          @keyup.enter.native="handleConfirm"
        />
      </b-field>
    </section>
    <footer class="modal-card-foot is-justify-content-flex-end">
      <b-button :disabled="isProcessing" @click="handleCancel">
        {{ cancelText }}
      </b-button>
      <b-button :type="type" :disabled="confirmDisabled" :loading="isProcessing" @click="handleConfirm">
        {{ confirmText }}
      </b-button>
    </footer>
  </section>
</template>

<style scoped>
.modal-card {
  width: 420px;
  max-width: calc(100vw - 32px);
}

.modal-card-body {
  white-space: normal;
}
</style>
